import React, { Component } from 'react';
import {ApplicationActions} from '../../../data/Action';

import time from '../../../script/utils/time';
import './orders-list.css';

export default class OrdersList extends Component {


    isOrderSelected(order) {

        let result =  (this.props.appState.order.selected && this.props.appState.order.selected.id === order.id);
        return result;
    }



    render() {


        // no orders to render
        if (!this.props.orders || this.props.orders.length && this.props.orders.length == 0){
            return null;
        }



        return (
            <div className="orders-list-wrapper">
                <div className="orders-list-header">
                    <span>Entregas</span>
                    <span className="orders-list-header-count">{ this.props.orders.length }</span>
                </div>
                <div className="orders-list">{
                    this.props.orders.map(order => (
                        <div
                            key={ order.id }
                            className={ `orders-list-item ${this.isOrderSelected(order) ? 'selected' : ''}` }
                            onClick={ () => this.updateSelectedOrder(order) }
                        >
                            <div className="orders-list-item-address">{ order.address }</div>
                            <div className="orders-list-item-timer">{ time.renderDeliveryDateTimer(order) }</div>
                        </div>
                    ))
                }</div>
            </div>
        );
    }





    updateSelectedOrder(order){
        if (this.isOrderSelected(order)){
            ApplicationActions.clearSelectedOrder();
        }else {
            ApplicationActions.updateSelectedOrder(order);
            setTimeout((orderId) => {
                ApplicationActions.clearSelectedOrder(orderId);
            }, 5000, order.id);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/Sidebar/orders-list/index.js